// extracted by mini-css-extract-plugin
export var dropdown = "_tf-0";
export var imageWrapper = "_tf-3";
export var itemNameContainer = "_tf-1";
export var productImage = "_tf-2";
export var spinnerWrapper = "_tf-4";